module.exports = __webpack_public_path__ + "img/1-18.3f90b6a7.jpg";